import { Menu, Typography } from 'antd';
import type { MenuProps } from 'antd';
import {
  BankOutlined,
  AuditOutlined,
  CalendarOutlined,
  DashboardOutlined,
  HomeOutlined,
  ProjectOutlined,
  ProfileOutlined,
  ScheduleOutlined,
  SettingOutlined,
  ShopOutlined,
  TagsOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { Role } from '@never2busy/shared';
import { useAuthStore } from '../../features/auth/stores/authStore';

interface SidebarProps {
  collapsed: boolean;
  /** Se llama al navegar; útil para cerrar el drawer en móvil. */
  onNavigate?: () => void;
}

const { Title } = Typography;

export function Sidebar({ collapsed, onNavigate }: SidebarProps): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useAuthStore((s) => s.user);

  const items: NonNullable<MenuProps['items']> = [
    { key: '/', icon: <HomeOutlined />, label: 'Inicio' },
    { key: '/cuentas', icon: <BankOutlined />, label: 'Cuentas' },
    { key: '/contactos', icon: <TeamOutlined />, label: 'Contactos' },
    { key: '/actividades', icon: <CalendarOutlined />, label: 'Actividades' },
    { key: '/calendario', icon: <ScheduleOutlined />, label: 'Calendario' },
    { key: '/proyectos', icon: <ProjectOutlined />, label: 'Proyectos' },
    { key: '/ventas', icon: <ShopOutlined />, label: 'Ventas' },
  ];

  if (user?.role === Role.ADMIN || user?.role === Role.GERENTE) {
    items.push({ key: '/admin/etiquetas', icon: <TagsOutlined />, label: 'Etiquetas' });
    items.push({ key: '/admin/catalogos', icon: <ProfileOutlined />, label: 'Catálogos' });
  }

  if (user?.role === Role.ADMIN) {
    items.push({ key: '/admin/usuarios', icon: <SettingOutlined />, label: 'Usuarios' });
    items.push({ key: '/admin/auditoria', icon: <AuditOutlined />, label: 'Auditoría' });
  }

  if (user?.canViewReports) {
    items.splice(1, 0, {
      key: '/reportes',
      icon: <DashboardOutlined />,
      label: 'Reportes',
    });
  }

  return (
    <div>
      <div
        style={{
          height: 64,
          display: 'flex',
          alignItems: 'center',
          justifyContent: collapsed ? 'center' : 'flex-start',
          padding: collapsed ? 0 : '0 16px',
          borderBottom: '1px solid #f0f0f0',
        }}
      >
        <Title level={4} style={{ margin: 0, color: '#1677ff' }}>
          {collapsed ? 'n2b' : 'never2busy'}
        </Title>
      </div>
      <Menu
        mode="inline"
        selectedKeys={[location.pathname.split('/').slice(0, 2).join('/')]}
        items={items}
        onClick={({ key }) => {
          navigate(key);
          onNavigate?.();
        }}
        style={{ borderRight: 0 }}
      />
    </div>
  );
}
